<script>
    import Registration from '../default/Registration';

    export default {
        extends: Registration,
        data: () => ({
            showPassword: false,
            rules:  {
                required: value => !!value || 'Dieses Feld wird benötigt und darf nicht leer sein.',
                length: value => (value ? (value.length >= 7 || 'Das Passwort muss mindestens 7 Zeichen haben.') : ''),
                email: value => /.+@.+/.test(value) || 'Bitte geben sie eine gültige Email-Adresse ein.',
                firstName: value => value ? (new RegExp('[a-zA-Z]+', 'i').test(value) || 'Das Vorname muss mindestens 1 Zeichen haben.') : '',
            },
        }),
    };
</script>
